import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {MatTooltip} from '@angular/material/tooltip';
import {RectangularButtonComponent} from '@aviary/buttons/base/rectangular-button/rectangular-button.component';
import {RectangularButtonContentComponent} from '@aviary/buttons/base/rectangular-button-content/rectangular-button-content.component';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';
import {ButtonFocusRingPosition} from '@aviary/buttons/button.types';

export type LinkButtonType = 'standalone' | 'inline';

@Component({
  selector: 'mx-link-button',
  host: {
    '[class.mx-link-button-standalone]': `linkType === 'standalone'`,
    '[class.mx-link-button-inline]': `linkType === 'inline'`,
    '[class.mx-link-button-truncate]': '!!truncateMaxLines'
  },
  templateUrl: './link-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: ROUTE_NAME_CAPABLE_BUTTON_COMPONENT, useExisting: LinkButtonComponent}
  ],
  imports: [NgTemplateOutlet, MatTooltip, BaseNamedRouterLinkDirective, RectangularButtonContentComponent]
})
export class LinkButtonComponent extends RectangularButtonComponent {
  // See BaseButtonComponent and RectangularButtonComponent for the rest of the available inputs.
  @Input() public linkType: LinkButtonType = 'standalone';
  @Input() public truncateMaxLines?: number;

  // Link buttons have no visible container shape to preserve, so their focus ring always sits outside the text.
  public override readonly focusRingPosition: ButtonFocusRingPosition = 'outside';
}
